import React from "react";
import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { connect, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getTemplateDetail } from "../../../actions/marketplace-action";
import ContentContainer from "../../common/ContentContainer";
import TemplateImage from "./TemplateImage";
import TemplateInfoCard from "./TemplateInfoCard";
import TemplateRentDetails from "./TemplateRentDetails";

const BotTemplateDetail = (props)=>{
    const template = useSelector((state)=>state.marketplace.template);
    const {getTemplateDetail} = props;
    let { id } = useParams();
    const {t} = useTranslation()
    useEffect(()=>{
        getTemplateDetail(id)
    },[id])
    return (
        <>
        <ContentContainer url="/marketplace" title="Marketplace" showExchange={false}>
            <div className="template-detail-div mt-5 ml-3">
                <Row>
                    <Col xl={3} className="mb-4 text-center">
                        <TemplateImage template={template} t={t}/>
                    </Col>
                    <Col xl={8}>
                        <TemplateInfoCard template={template} t={t}/>
                        <TemplateRentDetails template={template} t={t}/>
                    </Col>
                </Row>
            </div>
        </ContentContainer>
     </>
    );
}

export default connect(null,{getTemplateDetail})(BotTemplateDetail)